export const arizona = {
  name: "Arizona",
  locale: "en",
  numeric: "04",
  alpha2: "AZ",
  alpha3: "USA",
  code: "1",
  counties: {},
  codes: [],
  municipalities: {
    byCode: {},
    byCounty: {},
    codes: [],
  },
} as const;
